import { FC } from 'react';

import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetProfessionEvents } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { professionEventsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfProfessionEventsContainer: FC = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const events = useAppSelector(professionEventsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().professionEvents });

  const hasData = events.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(events, academicYears);
  return (
    <PdfCommonDataEntityContainer title="Мероприятия" Icon={IconWidgetProfessionEvents}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfProfessionEventsContainer;
